import React, { useCallback } from "react";

import { Location } from "history";
import { Prompt, useHistory } from "react-router-dom";

import { AnalyticsService } from "@app/util/analytic/AnalyticsService";
import useChangeLocationPrompt from "@app/util/hook/useChangeLocationPrompt";

import InterceptNavigationMessageModal from "./components/InterceptNavigationMessageModal";

interface Props {
  analyticIssuer?: AnalyticsService;
  leaveButtonText?: string;
  loading?: boolean;
  onLeave?: () => void;
  onSave?: () => void;
  onStay?: () => void;
  shouldCloseOnLeave?: boolean;
  shouldShowPrompt: ((location: Location) => boolean) | boolean;
  stayButtonText?: string;
  subTitle?: string;
  title?: string;
}

const InterceptNavigationModal: React.FC<Props> = ({
  analyticIssuer,
  leaveButtonText,
  loading,
  onLeave,
  onSave,
  onStay,
  shouldCloseOnLeave,
  shouldShowPrompt,
  stayButtonText,
  subTitle,
  title,
}) => {
  const history = useHistory();

  const { confirmLeave, handlePromptMessage, hide, visible } = useChangeLocationPrompt({
    history,
    onLeave,
    shouldCloseOnLeave,
    shouldShowPrompt,
  });

  const handleStay = useCallback(() => {
    hide();
    onStay?.();
  }, [hide, onStay]);

  const handleSave = useCallback(() => {
    hide();
    onSave?.();
  }, [hide, onSave]);

  return (
    <>
      <InterceptNavigationMessageModal
        analyticIssuer={analyticIssuer}
        leaveButtonText={leaveButtonText}
        loading={loading}
        onLeave={confirmLeave}
        onSave={onSave ? handleSave : undefined}
        onStay={handleStay}
        stayButtonText={stayButtonText}
        subTitle={subTitle}
        title={title}
        visible={visible}
      />
      <Prompt message={handlePromptMessage} when={shouldShowPrompt && !visible} />
    </>
  );
};

export default InterceptNavigationModal;
